import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { KatSpinner } from '@amzn/katal-react';
import Navigation from './Navigation';
import WarehouseUrlHandler from './WarehouseUrlHandler';
import { SelectedPickersProvider } from '../contexts/SelectedPickersContext';

// Route-level code splitting: each page is loaded on demand so a user landing on
// one route no longer downloads + parses every other page up front. Navigation and
// WarehouseUrlHandler stay statically imported because they are always rendered.
const Home = React.lazy(() => import('../pages/Home'));
const PickerDashboard = React.lazy(() => import('../pages/PickerDashboard'));
const PickerEligibilities = React.lazy(() => import('../pages/PickerEligibilities'));
const ClusterEligibilities = React.lazy(() => import('../pages/ClusterEligibilities'));
const ClusterManagement = React.lazy(() => import('../pages/ClusterManagement'));
const PickAreas = React.lazy(() => import('../pages/PickAreas'));
const AuditLog = React.lazy(() => import('../pages/AuditLog'));

const App = () => {
    return (
        <Router>
            {/* Reads /:warehouseId from URL and syncs it to localStorage/state */}
            <WarehouseUrlHandler />
            <Navigation />
            {/* SelectedPickersProvider shares the chosen associate logins across the
                Picker and Cluster Eligibilities pages so navigating between them
                does not drop the selection. */}
            <SelectedPickersProvider>
                {/* Inner Suspense keeps the navbar painted while a route chunk loads. */}
                <Suspense fallback={<KatSpinner size="large" />}>
                    <Routes>
                        {/* Routes with warehouse ID prefix — e.g. /BFI1/picker-eligibilities */}
                        <Route path="/:warehouseId/dashboard" element={<PickerDashboard />} />
                        <Route path="/:warehouseId/picker-eligibilities" element={<PickerEligibilities />} />
                        <Route path="/:warehouseId/cluster-eligibilities" element={<ClusterEligibilities />} />
                        <Route path="/:warehouseId/clusters" element={<ClusterManagement />} />
                        <Route path="/:warehouseId/pick-areas" element={<PickAreas />} />
                        <Route path="/:warehouseId/audit-log" element={<AuditLog />} />
                        <Route path="/:warehouseId" element={<Home />} />

                        {/* Legacy routes without warehouse prefix — still work as before */}
                        <Route path="/dashboard" element={<PickerDashboard />} />
                        <Route path="/picker-eligibilities" element={<PickerEligibilities />} />
                        <Route path="/cluster-eligibilities" element={<ClusterEligibilities />} />
                        <Route path="/clusters" element={<ClusterManagement />} />
                        <Route path="/pick-areas" element={<PickAreas />} />
                        <Route path="/audit-log" element={<AuditLog />} />
                        <Route path="/" element={<Home />} />
                    </Routes>
                </Suspense>
            </SelectedPickersProvider>
        </Router>
    );
};

export default App;
